import { render, staticRenderFns } from "./GStudentRecordTrends.vue?vue&type=template&id=7339d662&scoped=true&"
import script from "./GStudentRecordTrends.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecordTrends.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentRecordTrends.vue?vue&type=style&index=0&id=7339d662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7339d662",
  null
  
)

export default component.exports